<div class="pd-head">
  <h2 class="pd-title">Planning du dossier n° {{ data.orderId }}</h2>
  <span class="pd-spacer"></span>
  <a mat-stroked-button class="pd-page" [routerLink]="['/rental', data.orderId]" (click)="onPageLink($event)">Ouvrir la page du dossier</a>
  <button mat-icon-button type="button" class="pd-close" aria-label="Fermer" (click)="close()"><mat-icon>close</mat-icon></button>
</div>
<div class="pd-body">
  <app-rental-planning mode="dialog" (decided)="onDecided()" (navigated)="close()"></app-rental-planning>
</div>
